import {ReportNavigatorService} from '../../services/report-navigator.service';
import {TherapistScaleResultsComponent} from '../therapist-scale-results/therapist-scale-results.component';
import { Component, OnInit, ElementRef } from '@angular/core';
import { ScaleResult } from 'app/shared/models/scale-result';
import { PclGraderService } from 'app/reports/services/pcl-grader.service';

@Component({
  selector: 'app-pcl-assessment-results',
  templateUrl: './pcl-assessment-results.component.html'
})
export class PclAssessmentResultsComponent extends TherapistScaleResultsComponent implements OnInit {

  private _criteria:{name:string, hasPTSD:boolean, scaleResult:ScaleResult}[];
  

  constructor(navigator:ReportNavigatorService, el:ElementRef, private pclGrader:PclGraderService) {
    super(navigator, el);
 }

  ngOnInit() {
    super.ngOnInit();
    if (this.AssessmentResult) {
      this._criteria = this.pclGrader.getPCLCriteriaFromAssessmentResult(this.AssessmentResult);
    }
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  get Criteria() : {name:string, hasPTSD:boolean, scaleResult:ScaleResult}[] {
    return this._criteria;
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/report-items/pcl-assessment-results/pcl-assessment-results.component.ts